import React from "react";
import {stack as Menu} from "react-burger-menu";
import ChillyImage from "./Chilly_scout.png";
import "./Sidebar.css";

const Props = () => {
    return (
        <Menu>
            <img src={ChillyImage} alt="Chilly Scout" className="menu-logo" style={{width: "100%"}} />
            <a className="menu-item" href="/">
                Chilly Home Base
            </a>
            <a className="menu-item" href="/scouting">
                Scouting Sheet
            </a>
            <span>
                Ver. {process.env.REACT_APP_VERSION}
            </span>
        </Menu>
    );
};

export default Props;